import Backbone from 'backbone'
import template from './misc-components.hbs'
import BoxOptions from 'scoreboard/components/box-options'
import Tooltip from 'scoreboard/components/tooltip'

var MiscComponentsView = Backbone.View.extend({
	className: 'admin table-hack display-layout admin-test-view admin-test-misc-components',

	events: {
		'click .button-bootslide': 'displayBootslide'
	},

	render: function () {
		this.$el.empty().append(template())

		let options = [{
			title: 'Title',
			icon: 'layout-blank',
			value: 'eggs'
		},{
			title: 'Title',
			icon: 'layout-blank',
			value: 'bacon'
		},{
			title: 'Title',
			icon: 'layout-blank',
			value: 'orange-juice'
		},{
			title: 'Title',
			icon: 'performance-bubbles',
			value: 'pancake'
		},{
			title: 'Title',
			icon: 'layout-blank',
			isDisabled: true,
			value: 'toast'
		}]

		this.boxOptions = new BoxOptions({ availableOptions: options})
		this.$('.box-options-test .regular-box-options').append(this.boxOptions.el)
		this.boxOptions.render()

		this.boxOptions.on('select:disabled', ({ option, optionEl }) => {
			this.boxTooltip = new Tooltip({
				attachTo: optionEl,
				content: `Can't click me`,
				placement: 'above',
				arrow: 'center'
			})
			.render()
			.on('remove', () => delete this.boxTooltip)
		})

		this.fillBoxOptions = new BoxOptions({
			availableOptions: options,
			layout: 'fill'
		})
		this.$('.box-options-test .fill-box-options').append(this.fillBoxOptions.el)
		this.fillBoxOptions.render()

		this.longLabelsBoxOptions = new BoxOptions({
			availableOptions: [{
				title: 'This title is pretty long',
				icon: 'layout-blank',
				value: 'a'
			},{
				title: 'This title is even longer than the last one because it needs to be and so theres that',
				icon: 'layout-blank',
				value: 'b'
			},{
				title: 'This title is the longest of all because it needs to test out the box options when there are long labels',
				icon: 'layout-blank',
				value: 'c'
			},{
				title: 'This title is not so long but is kind of in the middle',
				icon: 'layout-blank',
				value: 'd'
			},{
				title: 'This title is pretty long',
				icon: 'layout-blank',
				value: 'e'
			}]
		})
		this.$('.box-options-test .label-lengths-box-options').append(this.longLabelsBoxOptions.el)
		this.longLabelsBoxOptions.render()

		this.sublabelBoxOptions = new BoxOptions({
			availableOptions: [{
				title: 'Title',
				icon: 'layout-blank',
				value: 'eggs',
				subLabel: 'This is a sublabel'
			},{
				title: 'Title',
				icon: 'layout-blank',
				value: 'bacon',
				subLabel: 'This is a sublabel'
			},{
				title: 'Title',
				icon: 'layout-blank',
				value: 'orange-juice',
				subLabel: 'This is a sublabel'
			},{
				title: 'Title',
				icon: 'performance-bubbles',
				value: 'pancake',
				subLabel: 'This is a sublabel'
			}]
		})
		this.$('.box-options-test .sub-labels-box-options').append(this.sublabelBoxOptions.el)
		this.sublabelBoxOptions.render()

		return this
	}
})

export default MiscComponentsView
